module.exports = __webpack_public_path__ + "img/viewpoint-animate2.4d72b7dd.png";